export class SupplierMessage {
  name: string
  website: string
  email: string
  phoneNumber: string
  addressLine1: string
  addressLine2: string
  city: string
  stateId?: number
  postalCode: string
  inventoryTypeIds: number[]

  constructor(
    name: string,
    website: string,
    email: string,
    phoneNumber: string,
    addressLine1: string,
    addressLine2: string,
    city: string,
    stateId: number|undefined,
    postalCode: string,
    inventoryTypeIds: number[]) {
      this.name = name
      this.website = website
      this.email = email
      this.phoneNumber = phoneNumber
      this.addressLine1 = addressLine1
      this.addressLine2 = addressLine2
      this.city = city
      this.stateId = stateId
      this.postalCode = postalCode
      this.inventoryTypeIds = inventoryTypeIds
  }
}
  